import React from 'react';
import { CITY_SEARCH_FORM_FIELD_NAME_DEFAULT } from '@cp/entities/location';
import { useEventCallback } from '@cp/ds/src/hooks/useEventCallback';
import { WatcherProps } from './watcher.interface';
import { FormModel } from './form';

export const Watcher: React.FC<WatcherProps> = (props) => {
  const { defaultCity, onChangeCity, form, defaultValues } = props;
  const onChangeCityMemoized = useEventCallback(onChangeCity);

  React.useEffect(() => {
    const city = form.getValues(CITY_SEARCH_FORM_FIELD_NAME_DEFAULT);

    if (defaultCity && defaultCity.id !== city?.id) {
      form.setValue(CITY_SEARCH_FORM_FIELD_NAME_DEFAULT, defaultCity);
    }
  }, [defaultCity, form]);

  React.useEffect(() => {
    const subscription = form.watch((values, info) => {
      if (info.type !== 'change') {
        return;
      }

      /**
       * City changes
       */
      const city = values[CITY_SEARCH_FORM_FIELD_NAME_DEFAULT] as FormModel[typeof CITY_SEARCH_FORM_FIELD_NAME_DEFAULT];

      if (info.name === CITY_SEARCH_FORM_FIELD_NAME_DEFAULT && city && defaultValues[CITY_SEARCH_FORM_FIELD_NAME_DEFAULT]?.id !== city.id) {
        onChangeCityMemoized?.(city);
      }
    });
    return () => subscription.unsubscribe();
  }, [defaultValues, form, onChangeCityMemoized]);

  return null;
};
